import React, {useState} from 'react';
import SimpleInput from "./SimpleInput";
import {t} from "../../services/i18n";
import {GlobalConsts} from "../../styles/GlobalConsts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Colors} from "../../styles/Colors";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";

const SearchInput = (props) => {
    const { onChange, inputStyleOverride, ...rest } = props;
    const [searchInput, setSearchInput] = useState('');

    const onSearchInputChanged = (input) => {
        setSearchInput(input)
        if(onChange) onChange(input)
    }

    return (
        <SimpleInput unstyled
                     value={searchInput}
                     onChangeCallback={(val) => onSearchInputChanged(val)}
                     placeholder={t('search')}
                     prefix={<FontAwesomeIcon icon={light('magnifying-glass')} fontSize={GlobalConsts.iconSize.XS} color={Colors.newDesign.darkGrey}/>}
                     allowClear={true}
                     className={'search-input'}
                     {...rest}
        />
    );
};

export default SearchInput;
